import I18N from '@leverege/i18n';
import CreateLayoutEditor from "./CreateLayoutEditor.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.dataViewers.layout.SaveAsLayoutAction');
export default {
  id: 'molten.dataViewers.layout.SaveAsLayoutAction',
  name: tf('name'),
  matches: {
    use: 'mobileLayoutActionBar'
  },
  layout: {
    sort: 'a2'
  },
  handles: context => {
    return context?.layout?.layoutVersions != null;
  },
  appearance: ({
    context
  }) => {
    return {
      name: t('name'),
      icon: tIcon('save', 'https://molten-ui-assets.storage.googleapis.com/save.svg'),
      variant: 'layoutAction'
    };
  },
  perform: props => {
    const {
      context,
      onClose
    } = props;
    CreateLayoutEditor.show({
      layoutVersions: context?.layout?.layoutVersions,
      onLayoutSave: context?.layout?.onLayoutSave,
      onClose
    });
  }
};